import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerFormPayload } from "modules/DealersDashboard/components/CreateDealerModal/hooks";

const FormHelper = createFormHelper<DealerFormPayload>();

export const CreateDealerForm = () => {
  const { t } = useTranslation();
  const { watch, formState } = FormHelper.useFormContext();

  const name = watch("name");

  return (
    <>
      <Form.Group>
        <Form.Field width={8} required error={formState.isSubmitted && !name}>
          <label>{t("v8_company_name", "Company name")}</label>
          <FormHelper.Field.Input name="name" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_region", "Region")}</label>
          <FormHelper.Field.Input name="region" />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_city", "City")}</label>
          <FormHelper.Field.Input name="city" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_street", "Street")}</label>
          <FormHelper.Field.Input name="street" />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_postal_code", "Postal code")}</label>
          <FormHelper.Field.Input name="postal_code" />
        </Form.Field>
        <Form.Field width={8}>
          <label>{t("v8_phone", "Phone")}</label>
          <FormHelper.Field.Input name="phone_nr" />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={8}>
          <label>{t("v8_website_url", "Website URL")}</label>
          <FormHelper.Field.Input name="website_url" />
        </Form.Field>
      </Form.Group>
    </>
  );
};
